var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_error)?_c('base-alert',{attrs:{"level":"danger"}},[_c('template',{slot:"heading"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('template',{slot:"content"},[_vm._v(_vm._s(_vm.detail))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }